<style>
    html, body{
        width: 100%;
        height: 100%;
        margin: 0;
        overflow: hidden;
    }
    body {
        /* background: #DFE9FB; */
        min-width: 1000px;
        min-height: 700px;
        background:url(../assets/images/login_bg01.jpg) no-repeat;
        background-size: 100% 100%;
    }
</style>
<style lang="scss">
    .login-box{
        width: 100%;
        height: 100%;
    }
    .login-con-bg{
        width: 1000px;
        height: 590px;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        /*padding: 200px 0;*/
    }
    .login-top-bg{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background:url(../assets/images/login_bg02.png) left top no-repeat;
        background-size: 80% auto;
    }
    .login-con-info{
        text-align: center;
        /*padding: 200px 0;*/
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .logo-left{
        position: absolute;
        top: 30px;
        left: 60px;
        margin: 0;
        font-size: 26px;
    }
    .logo-left img{
        vertical-align: middle;
        margin-right: 15px;
    }
    .info-con{
        width: 1000px;
        height: 590px;
        margin: 0 auto;
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }
    .con-radio{
        position: absolute;
        width: 500px;
        left: 30px;
        top: 110px;
        // height: 360px;
        height: 405px;
        background: #fff;
        border: 1px solid #eee;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        box-shadow: -1px 0px 24px 0px rgba(153,153,153,0.28);
        font-size: 16px;
        padding: 10px;
        text-align: left;
        .title{
            padding: 15px 0;
            text-align: center;
            font-size: 16px;
            color: #000;
            font-weight: 600;
            font-family: 微软雅黑;
        }
        .radio-box{
            padding: 10px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            font-size: 14px;
            li{
                width: 170px;
                padding: 15px;
                border-radius: 5px;
                box-shadow: -1px 0px 10px 0px rgba(153,153,153,0.28);
                font-weight: 600;
                margin: 15px 18px;
                cursor: pointer;
                border: 1px solid #fff;
                height: 24px;
                line-height: 24px;
                img{
                    width: 24px;
                    height: 24px;
                    vertical-align: middle;
                    margin-right: 10px;
                }
                label{
                    cursor: pointer;
                }
            }
            li:nth-of-type(2n+1) img{
                width: 20px;
                height: 20px;
            }
            li.active{
                border: 1px solid #30AAFF;
            }
        }
    }
    .con-form{
        width: 330px;
        position: absolute;
        right: 60px;
        top: 110px;
        text-align: left;
        .title {
            padding: 15px 0 40px;
            font-size: 24px;
            color: #000;
        }
    }
    .con-form .el-input__inner{
        border: none;
        border-bottom: 1px solid #a6a6a6;
        border-radius: 0;
        padding: 0;
        background: transparent;
        color: #323232;
    }
    .con-form .error .el-input__inner{
        border-bottom: 1px solid #2878ff;
    }
    .con-form .el-form-item__content label{
        display: block;
        color: #a6a6a6;
        line-height: 20px;
    }
    .form-btn{
        margin-top: 40px;
    }
    .form-btn .el-button{
        background: #476eff;
        height: 55px;
    }
    .error-text{
        color: #f92c2c;
        line-height: 22px;
        height: 22px;
        font-size: 14px;
        font-family: 微软雅黑;
        margin-top: 10px;
    }
</style>
<template>
    <!--<div class="data-bg">-->
        <!--<h3 class="logo-left"><img src="../assets/images/logo01.png" width="200"/></h3>-->
        <!--<div class="login-margin">-->
            <!--<div class="login-form">-->
                <!--<el-form ref="formLogin" :model="formLogin" :rules="ruleLogin" label-position="left" label-width="0px"-->
                         <!--class="demo-ruleForm login-container" style="margin-top: 40px; float: left;">-->
                    <!--<h3 class="title" style="color: white; font-family: Adobe 黑体 Std">登 录</h3>-->
                    <!--<el-form-item prop="userName">-->
                        <!--<el-input type="text" v-model="formLogin.userName" auto-complete="off" placeholder="账号"></el-input>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item prop="password">-->
                        <!--<el-input type="password" v-model="formLogin.password" auto-complete="off" placeholder="密码"></el-input>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item style="width:100%;">-->
                        <!--<el-button type="primary" style="width:100%; font-size: 18px; margin-top: 10px;" @click.native.prevent="login('formLogin')" >登 录</el-button>-->
                    <!--</el-form-item>-->
                <!--</el-form>-->
            <!--</div>-->
        <!--</div>-->
        <!--<div class="footer" style="position: fixed; bottom: 30px; width: 100%;">-->
            <!--<p>中宣部信息中心监测处监制｜开发者：杭州作客文化传媒有限公司</p>-->
        <!--</div>-->
    <!--</div>-->
    <div class="login-box">
        <div class="login-con-bg">
            <img src="../assets/images/login_con_bg.png" width="1000"/>
        </div>
        <div class="login-top-bg"></div>
        <div>
            <div class="login-con-info">
                <h3 class="logo-left"><a><img src="../assets/images/logo01.png" height="70"/>作客小程序管理中心</a></h3>
                <div class="info-con">
                    <div class="con-radio">
                        <div class="title">请选择您要登录的小程序平台</div>
                        <ul class="radio-box">
                            <li v-for="(item, index) in platformList" :class="activeIndex == index ? 'active' : ''" :key="index" @click="changePlatform(item, index)">
                                <img :src="item.href"/>
                                <label>{{item.name}}</label>
                            </li>
                        </ul>
                    </div>
                    <div class="con-form">
                        <el-form ref="formLogin" :model="formLogin" label-position="left" label-width="0px">
                            <h3 class="title" style="font-family: 微软雅黑">登录作客小程序管理中心</h3>
                            <el-form-item prop="userName">
                                <label>账户</label>
                                <el-input type="text" v-model="formLogin.userName" :class="errorUser ? 'error': ''" auto-complete="off" placeholder="请输入账户"></el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <label>密码</label>
                                <el-input type="password" v-model="formLogin.password" :class="errorPw ? 'error': ''" auto-complete="off" placeholder="请输入密码"></el-input>
                                <p class="error-text">{{errorText}}</p>
                            </el-form-item>
                            <el-form-item class="form-btn">
                                <el-button type="primary" style="width:100%; font-size: 18px;" @click="login" >登 录</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer" style="position: absolute; bottom: 15px; width: 100%;">
            <p>开发者：杭州藏峰文化传媒有限公司</p>
        </div>
    </div>
</template>
<script>
    import pngDy from '../assets/images/logo_dy.png'
    import pngWb from '../assets/images/logo_wb.png'
    import pngWx from '../assets/images/logo_wx.png'
    export default {
        data () {
            return {
                errorUser: false,
                errorPw: false,
                errorText: '',
                formLogin: {
                    userName: '',
                    password: ''
                },
                cdId: '1',
                platformList: [
                    {
                        id: 'dy-dp',
                        href: pngDy,
                        name: '抖音-短篇/长篇小程序'
                    },
                    {
                        id: 'wb-dp',
                        href: pngWb,
                        name: '微博-短篇小程序'
                    },
                    {
                        id: 'dy-sv',
                        href: pngDy,
                        name: '抖音-作客短剧小程序'
                    },
                    {
                        id: 'wb-sv',
                        href: pngWb,
                        name: '微博-短剧小程序'
                    },
                    {
                        id: 'gg-sv',
                        href: pngDy,
                        name: '抖音-国广短剧小程序'
                    },
                    {
                        id: 'wx-sv',
                        href: pngWx,
                        name: '微信-作客短剧小程序'
                    },
                    {
                        id: 'wx-gg-sv',
                        href: pngWx,
                        name: '微信-国广短剧小程序'
                    },
                    {
                        id: 'wx-dp',
                        href: pngWx,
                        name: '微信-短篇小程序'
                    },
                ],
                activeIndex: 2
                
            }
        },
        mounted () {
            console.log(this.$route)
            console.log(this.$route.query.redirect)
            if(this.$route.query.redirect){
                console.log(11)
            }
            localStorage.setItem('platform', 'dy-sv')
        },
        methods: {
            changePlatform(item, index) {
                this.activeIndex = index
                localStorage.setItem('platform', item.id)
            },
            login () {
                console.log(this.formLogin.userName)
                if (this.formLogin.userName === '') {
                    this.errorUser = true
                    this.errorPw = false
                    this.errorText = '* 请输入账户'
                } else if (this.formLogin.password === '') {
                    this.errorUser = false
                    this.errorPw = true
                    this.errorText = '* 请输入密码'
                } else {
                    this.errorUser = false
                    this.errorPw = false
                    this.errorText = ''
                    this.$store.dispatch('home/loginTest', { 'username': this.formLogin.userName, 'password': this.formLogin.password, 'router': this.$router, 'route': this.$route, 'toast': this.$toast, 'redirect': this.$route.query.redirect })
                }
                // this.$refs[formLogin].validate((valid) => {
                //     if (valid) {
                //         this.$store.dispatch('home/loginTest', { 'username': this.formLogin.userName, 'password': this.formLogin.password, 'router': this.$router, 'route': this.$route, 'toast': this.$toast })
                //         // document.getElementById('TencentCaptcha').click()
                //         // this.$store.dispatch('users/userLogin', {'userName': this.formLogin.userName, 'userPassword': this.formLogin.password, 'router': this.$router})
                //     }
                // })
            }
        }
    }
</script>